<template>
  <list ref="list" :key="state" :state="state">
    <ul class="tabs" slot="search">
      <li v-for="(item, index) in stateOptions" :key="index" :class="{ selected: state == item.value }" @click="state = item.value">
        {{ item.text }}
      </li>
    </ul>
    <el-dropdown slot="column" slot-scope="{ data }">
      <el-link type="info" v-if="data.Surplus < 0 && data.State != 9 && data.State != -1">逾期终止</el-link>
      <el-link type="primary" v-else-if="data.State == 9">{{ data.ResultText }}<i class="el-icon-arrow-down" /></el-link>
      <el-link type="primary" v-else>{{ data.StateText }}<i class="el-icon-arrow-down" /></el-link>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="$router.push({ path: 'create', query: { id: data.Id } })">修改</el-dropdown-item>
        <el-dropdown-item @click.native="onDelete(data)" style="color: #f00">{{ data.State == 0 || data.State == -1 ? '删除' : '作废' }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </list>
</template>


<script>
export default {
  components: { list: () => import("./_list.vue") },
  data () {
    return {
      state: null,
      stateOptions: [
        { text: '全部' },
        { text: '无效', value: -1 },
        { text: '未截单', value: 0 },
        { text: '报价中', value: 1 },
        { text: '投标中', value: 2 },
        { text: '结束', value: 9 }]
    }
  },
  methods: {
    //删除
    onDelete (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', row.Title, {
        center: true
      }).then(() => {
        this.$apis.project.inquiry.delete({ id: row.Id }).then(() => {
          this.$refs.list.loadData()
          this.$message({ message: "执行成功！", type: "success" })
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }
}
</script>


<style lang="scss" scoped>
ul.tabs {
  display: flex;
  padding: 0 16px;
  li {
    list-style: none;
    padding: 5px 0;
    position: relative;
    cursor: pointer;
  }
  li + li {
    margin-left: 20px;
  }
  li.selected {
    color: #409eff;
  }
  li.selected::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background: #409eff;
  }
}
</style>